<script>
export default {
   name: 'DeclarationItem',
   props: {
      active: {
         type: Boolean,
         required: true,
      },
      value: {
         type: [String, Boolean],
         default: false,
      },
      disabled: {
         type: Boolean,
         default: false,
      },
      expenseType: {
         type: String,
         required: true,
         validator: (value) => ['cloud', 'supplies', 'contractors', 'employees'].includes(value),
      },
   },
   methods: {
      onDeclare() {
         if (this.disabled) {
            this.$store.commit('showAlert', {
               msg: `This answer can't be changed when uploaded ${this.expenseType} data exists`,
               seconds: 5,
            });
            return;
         }
         this.$emit('input-declared', this.value);
      },
   },
};
</script>

<template>
   <div class="declaration-item d-flex flex-row" :class="{active, disabled}" @click="onDeclare">
      <div class="d-flex flex-row align-items-start justify-content-center" style="gap: 3rem">
         <div class="d-flex flex-column">
            <div class="icon-container">
               <slot name="icon" />
            </div>
            <div class="description" style="text-align: center">
               <slot name="description" />
            </div>
         </div>
      </div>
      <img v-if="active" src="@/assets/img/green-checkmark.svg" alt="checkmark" class="mt-2" />
   </div>
</template>

<style scoped lang="scss">
.declaration-item {
   background-color: white;
   font-weight: normal;
   height: 210px;
   padding: 1rem;
   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
   border: 1px solid white;
   border-radius: 10px;
   align-items: center;
   justify-content: center;
   position: relative;
   max-width: calc(50% - 0.5rem);
   flex: 50%;
   cursor: pointer;

   @include lg {
      flex: 1;
      flex-basis: 0;
   }

   .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 115px;
   }

   img {
      position: absolute;
      right: 1rem;
      top: 1rem;
   }

   .description {
      text-align: center;
      font-size: 0.8125rem;
   }

   &:hover:not(.disabled) {
      border-color: $primary;
   }

   &.disabled {
      cursor: auto;
   }

   &.active {
      background-color: white;
      color: black;
      border: 1px solid dodgerblue;
   }
}
</style>
